import { createFileRoute } from "@tanstack/react-router";
import NewPurchasedItem from "@/features/inventory/NewPurchasedItem";

export const Route = createFileRoute("/inventory/purchased/new")({
  component: () => (
    <div className="max-w-3xl mx-auto p-4">
      <NewPurchasedItem />
    </div>
  ),
});
